import React from "react";
// @ts-ignore
import EventRow from "react-big-calendar/lib/EventRow";

interface MyLeaveCalendarTimelineWeekWrapperProps {
  slotMetrics: {
    levels: any[]; // Replace 'any' with the actual type if known
  };
  [key: string]: any; // Add other props as needed
}

export const MyLeaveCalendarTimelineWeekWrapper = (
  props: MyLeaveCalendarTimelineWeekWrapperProps,
) => {
  // TODO: implement grouping
  // We need to find out, which is the best grouping method
  // Unitl that the grouping feature is didabled
  //const groupBy = (levels) => {
  //  let result = levels.reduce(
  //    (result, item) => ({
  //      ...result,
  //      [item.event.title]: [...(result[item.event.title] || []), item],
  //    }),
  //    {}
  //  );
  //  return Object.values(result);
  //};

  const compare = (a: any[], b: any[]) => {
    // Compare events by their start date
    const dateA = a[0].event.start;
    const dateB = b[0].event.start;

    // Handle both Date objects and ISO string dates
    if (dateA instanceof Date && dateB instanceof Date) {
      return dateA.getTime() - dateB.getTime();
    }

    // For ISO strings or mixed types, use string comparison
    const strA = String(dateA);
    const strB = String(dateB);
    return strA.localeCompare(strB);
  };

  let levels: any[] = [];
  let origLevels = props.slotMetrics.levels;

  for (const item of origLevels) {
    levels = levels.concat(item);
  }

  let arrayLevels = levels.map((item) => {
    let newItem = [];
    newItem.push(item);
    return newItem;
  });

  arrayLevels.sort(compare);

  return (
    <React.Fragment>
      {arrayLevels.map((item, idx) => {
        return <EventRow key={idx} segments={item} {...props} />;
      })}
    </React.Fragment>
  );
};

export default MyLeaveCalendarTimelineWeekWrapper;
